<!--
 * @description: 
 * @author: Jason Wong
 * @since: 2020-05-07 11:54:29
-->
<template>
  <div
    :title="title"
    @click="!disabled && $emit('click')"
    :class="['ve-icon-button', disabled ? 'disabled' : null]"
  >
    <font-awesome-icon :icon="icon"></font-awesome-icon>
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
    },
    title: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
.ve-icon-button{
    &.disabled{
        cursor: not-allowed;
    }
}
</style>
